import "./RightBar.css";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { MdOutlineLogout } from "react-icons/md";
import { FaUserPen, FaAngleDown } from "react-icons/fa6";
import ApplicationRightBar from '../../../../../../application/components/layout/ApplicationRightBar';
import config from "../../../../../../application/config/config";

function RightBar() {
  const navigate = useNavigate();
  const userSession = useSelector((state) => { return state.session.userSession });

  const imageLink = !userSession.user.photo.includes('http') ? `${config.endpoints.backend}${userSession.user.photo}` : userSession.user.photo

  return (
    <>
      <ul className="right-bar-container navbar-nav mr-auto w-auto">
        {/* <li className="nav-item select-width"> */}
        <ApplicationRightBar />
        {/* </li> */}
      </ul>
      {/*       <ul className="navbar-nav w-auto">
        <div className='app-name'>
          {userSession.user.instance_name}
        </div>
      </ul> */}
      <ul className="navbar-nav ml-3 d-flex align-items-center">
        <span className='divider' />
        <li className="nav-item dropdown">
          <div className="nav-link user-panel d-flex align-items-center item-height" data-testid="right-menu-options" data-toggle="dropdown">
            <div>
              <img style={{ width: '44px' }} src={userSession.user.photo ? imageLink : '/dist/img/anonymous-avatar.jpeg'} className="img-circle" alt="User Image" />
            </div>
            <div className="mx-3 profile__user__button">
              <span className="d-block user-name">{userSession.user.name}</span>
              <span className="d-block user-type">{userSession.user.profile_name}</span>
            </div>
            <FaAngleDown />
          </div>
          <div className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
            <a data-testid="right-menu-options-user-info" className="dropdown-item" href="#" onClick={() => navigate('/core/users/useredit')}>
              <FaUserPen /> Meus dados
            </a>
            <div className="dropdown-divider"></div>
            <a data-testid="right-menu-options-logout" className="dropdown-item" href="#" onClick={() => navigate('/logout')}>
              <MdOutlineLogout /> Logout
            </a>
          </div>
        </li>
      </ul>
    </>
  );
}

export default RightBar;
